<app-header
  icon="fas fa-home"
  text="Startseite"
  sub="Individualisieren Sie die Inhalte Ihrer Atlas-Startseite."></app-header>
<p-divider />
@if (form) {
  <form [formGroup]="form" (ngSubmit)="submit()" class="p-fluid">
    <div class="grid">
      <app-form-field-wrapper
        [label]="'Überschrift'"
        [name]="'headline'"
        [colSize]="12">
        <input
          pInputText
          id="headline"
          type="text"
          formControlName="headline"
          class="p-input" />
      </app-form-field-wrapper>
      <app-form-field-wrapper
        [label]="'Hier können Sie einen kurzen Begrüßungstext eingeben!'"
        [name]="'startTeaser'"
        [colSize]="12">
        <input
          pInputText
          id="startTeaser"
          type="text"
          formControlName="startTeaser"
          class="p-input" />
      </app-form-field-wrapper>
    </div>
  </form>
  <p-divider />
}

<p-pickList
  #listPickerCtrl
  filterBy="name"
  [source]="availableItems"
  [target]="selection"
  sourceHeader="Ansichten, Themen und Berichte"
  targetHeader="Auswahl für die Startseite"
  [dragdrop]="true"
  [responsive]="true"
  breakpoint="1400px"
  sourceFilterPlaceholder="durchsuchen ..."
  targetFilterPlaceholder="durchsuchen ..."
  [showSourceControls]="false"
  [sourceStyle]="{ height: '30rem' }"
  [targetStyle]="{ height: '30rem' }"
  (onMoveToSource)="saveToAtlasConfig()"
  (onTargetReorder)="saveToAtlasConfig()"
  (onMoveToTarget)="saveToAtlasConfig()"
  (onMoveAllToSource)="saveToAtlasConfig()"
  (onMoveAllToTarget)="saveToAtlasConfig()">
  <ng-template let-item pTemplate="item">
    <div class="flex gap-3 align-items-center">
      <i class="w-1rem text-center" [class]="item.icon"></i>
      <span>{{ item.name }}</span>
    </div>
  </ng-template>
  <ng-template pTemplate="sourceHeader">
    Ansichten und Themen <br />
    <span class="font-light text-color-secondary text-xs"
      >Hier wählen Sie aus, welche Inhalte auf der Startseite angezeigt
      werden.</span
    >
  </ng-template>
</p-pickList>
